import { render, staticRenderFns } from "./PaginationContainerNew.vue?vue&type=template&id=fb6699aa&scoped=true"
import script from "./PaginationContainerNew.vue?vue&type=script&lang=js"
export * from "./PaginationContainerNew.vue?vue&type=script&lang=js"
import style0 from "./PaginationContainerNew.vue?vue&type=style&index=0&id=fb6699aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6699aa",
  null
  
)

export default component.exports